import { GetterTree } from 'vuex';
import { DirectDebitState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<DirectDebitState, RootState> = {
  ['getDirectDebit']: (state) => state.directDebit,
  ['getCreditTransferForTrainers']: (state) => state.creditTransferForTrainers,
};
